var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWithoutText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    width: 50,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 64",
    style: {
      enableBackground: "new 0 0 50 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.5,48c0,3-2.7,5.4-6,5.4h-4.9c-3.4,0-6.7,1-9.5,2.8c-0.1,0-0.1,0.1-0.2,0.1c0,0-0.1-0.1-0.2-0.1 c-2.9-1.8-6.2-2.8-9.5-2.8h-4.9c-3.3,0-6-2.4-6-5.4V6.5h31.9V2.1H0V48c0,5.4,4.7,9.8,10.4,9.8h4.9c6.2,0,9.7,4.2,9.7,4.2 s3.4-4.2,9.7-4.2h4.9c5.7,0,10.4-4.4,10.4-9.8V15.6h-4.4V48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.6,2.1L38.6,2.1l0,4.4h3.9L25,20.1l-11.4-8.9l-7,5.5l0,26.3L25,54.9L43.5,43V21.2h0l0,0l-5-3.2l-1.9,1.5 l2.7,1.8L25,30.5l-14.3-9.3l4.5-3l9.7,7.6L45.5,9.6v3.8H50V2.1H38.6z M41.3,41.7l-6,3.9v-8.4l0,0l0-1v-1.7l0,0l0,0l-9.1,5.9v-8 l15.1-9.8V41.7z M23.9,40.5L23.9,40.5l-9.1-5.9l0,0.2l0,0v10.8l-5.8-3.7V22.6l15,9.8V40.5z M17,47v-8.3l8,5.2l0,0l0,0l1.1-0.7h0 l0,0l6.9-4.5V47l-8,5.2v0L17,47z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithoutText);
export default __webpack_public_path__ + "static/media/LogoWithoutText.a28ad6e1bfb2c93d657a347b94c32db7.svg";
export { ForwardRef as ReactComponent };